(function () {
  function copyURI(evt) {
    evt.preventDefault();
    navigator.clipboard.writeText(window.location.href);

    // Show "COPY!" tooltip
    const button = evt.currentTarget;

    // Remove existing tooltip if any
    const existingTooltip = button.querySelector('.copy-tooltip');
    if (existingTooltip) {
      existingTooltip.remove();
    }

    // Create tooltip
    const tooltip = document.createElement('span');
    tooltip.className = 'copy-tooltip';
    tooltip.textContent = 'COPY!';
    button.appendChild(tooltip);

    // Remove tooltip after animation
    setTimeout(() => {
      tooltip.remove();
    }, 1500);
  }

  const copyLinks = document.querySelectorAll('.copy-btn');

  for (const copyLink of copyLinks) {
    copyLink.addEventListener('click', copyURI);
  }
})();
